// @ts-check
import { useState } from 'react';
import { Flex, Padding } from 'components/base/layout-components';
import Text, { Inline } from 'components/base/Text';
import WarningDude from 'images/characters/warning-dude.svg';
import styled from 'styled-components';
import { LBButton } from '@linearb/buzz';

const StyledImg = styled.img`
  width: 150px;
  padding-right: 3rem;
`;

const DeleteTeamModal = ({
  title,
  confirmText,
  cancelText,
  onCancel,
  onConfirm,
  buttonsContainerFlexDirection = 'row-reverse',
  descriptionTextWidth,
  accountsNames = [],
  teamName,
  type,
  extraText
}) => {
  const [saving, setSaving] = useState(false);

  return (
    <Padding padding='medium'>
      <Flex direction='column' justify='space-between'>
        <Flex width='100%' items='start'>
          <StyledImg src={WarningDude} alt='' />
          <Flex direction='column' justify='space-between'>
            <Flex width='100%' pb='1.5rem'>
              {title ? <Text size='x-x-large'>{title}</Text> : null}
            </Flex>
            {!accountsNames.length ? (
              <Text size='large' lineHeight='1.8rem' pb='big' pt='medium'>
                Are you sure you want to delete the {teamName}
                {type}?{extraText}
              </Text>
            ) : (
              <>
                <Text size='large' lineHeight='large' pb='big' pt='medium'>
                  You are about to delete the only team of the
                </Text>
                <Text size='large' lineHeight='1.5'>
                  following users:
                </Text>
                <Text
                  size='large'
                  lineHeight='large'
                  color='osloGray'
                  pt='1rem'
                >
                  {accountsNames.map((accountName, i) => (
                    <Inline key={accountName + i} size='large' color='osloGray'>
                      {accountName}{' '}
                    </Inline>
                  ))}
                </Text>
                <Text size='large' lineHeight='large' pt='1rem'>
                  Users without a team can not log in to LinearB.
                </Text>
                <Text size='large' lineHeight='large' pt='2rem' pb='2rem'>
                  Are you sure?
                </Text>
              </>
            )}
          </Flex>
        </Flex>
        <Flex direction={buttonsContainerFlexDirection} pt='2rem'>
          <Padding r={descriptionTextWidth ? 'small' : null}>
            <LBButton
              disabled={saving}
              onClick={async () => {
                setSaving(true);
                await onConfirm();
                setSaving(false);
              }}
            >
              {confirmText}
            </LBButton>
          </Padding>
          <Padding r={!descriptionTextWidth ? 'small' : null}>
            <LBButton
              variant='outline'
              onClick={() => {
                onCancel();
              }}
            >
              {cancelText}
            </LBButton>
          </Padding>
        </Flex>
      </Flex>
    </Padding>
  );
};
export default DeleteTeamModal;
